// Shared password complexity rules, kept in sync with the backend's
// validate_password_complexity() in app/core/auth.py.
export const PASSWORD_HINT =
  'At least 8 characters, with an uppercase letter, a lowercase letter, a number, and a symbol.';

export function getPasswordComplexityErrors(password) {
  const errors = [];
  const value = password || '';
  if (value.length < 8) errors.push('at least 8 characters');
  if (!/[A-Z]/.test(value)) errors.push('an uppercase letter');
  if (!/[a-z]/.test(value)) errors.push('a lowercase letter');
  if (!/[0-9]/.test(value)) errors.push('a number');
  if (!/[^A-Za-z0-9]/.test(value)) errors.push('a symbol (e.g. ! @ # $ %)');
  return errors;
}
